var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("h2", { staticClass: "is-size-3" }),
      _c(
        "nav",
        {
          staticClass: "breadcrumb p-l-sm p-r-sm",
          attrs: { "aria-label": "breadcrumbs" }
        },
        [
          _c("ul", [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/dashboard" } }, [
                  _vm._v(_vm._s(_vm.$t("menu.dashboard")))
                ])
              ],
              1
            ),
            _c("li", { staticClass: "is-active" }, [
              _c("a", { attrs: { href: "#", "aria-current": "page" } }, [
                _vm._v(_vm._s(_vm.$t("breadcrumb.news_info_manage")))
              ])
            ])
          ])
        ]
      ),
      _c("NewsList", { staticClass: "p-t-md p-l-lg p-r-lg" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }